/**
 * AP Invoices Demo — line-item match provenance chip wrapper.
 *
 * THROWAWAY DEMO CODE. Wraps the product `MatchProvenanceChip` for a matched
 * invoice line and, for web-search matches, wires a "Save to memory" CTA that
 * persists to the demo store — flipping the chip to a "saved to memory"
 * confirmation. Renders nothing when the demo has no provenance for the line.
 */

import { MatchProvenanceChip } from '@/components/accounts-payable/shared/match-provenance-chip';
import { updateApDemoState } from './fixture-store';
import { useApLineItemProvenance, useApLineMemorySaved } from './provenance';

export function ApLineMatchProvenanceChip({
  lineItemId,
}: {
  lineItemId: string;
}) {
  const provenance = useApLineItemProvenance(lineItemId);
  const saved = useApLineMemorySaved(lineItemId);

  if (!provenance) return null;

  const handleSaveToMemory = () => {
    updateApDemoState((s) => {
      s.lineMemorySavedById[lineItemId] = true;
    });
  };

  return (
    <MatchProvenanceChip
      provenance={provenance}
      savedToMemory={saved}
      onSaveToMemory={
        provenance.kind === 'web-search' ? handleSaveToMemory : undefined
      }
    />
  );
}
